// Part 1
import { createSlice } from "@reduxjs/toolkit"

// Part 2
export interface ReportErrorInitialState {
  addressId: string;
  serviceAddressList: { label: string; value: string }[];
  currentSelectedTabIndex: number;
  selectedTab: any,
  setSelectedServiceHistoryTab: any,
  currentSelectedServiceHistoryTabIndex: number;
  showUpdateService: boolean;
  activeTab: "CURRENT_SERVICE" | "UPDATED_SERVICE"
  isServiceAddressSaved: boolean;
  openDeleteServiceDetailTabModal: boolean;
}

const initialState: ReportErrorInitialState = {
  addressId: '',
  serviceAddressList: [],
  currentSelectedTabIndex: 0,
  selectedTab: null,
  setSelectedServiceHistoryTab: null,
  currentSelectedServiceHistoryTabIndex: 0,
  showUpdateService: false,
  activeTab: "CURRENT_SERVICE",
  isServiceAddressSaved: false,
  openDeleteServiceDetailTabModal: false
}

// Part 3
export const serviceDetailSlice = createSlice({
  name: 'serviceDetails',
  initialState,
  reducers: {
    setServiceAddressId: (state, action) => {
      state.addressId = action.payload
    },

    setServiceAddressList: (state, action) => {
      state.serviceAddressList = action.payload
    },

    setSelectedTab: (state, action) => {
      state.selectedTab = action.payload
    },

    setSelectedServiceHistoryTab: (state, action) => {
      state.selectedTab = action.payload
    },

    setCurrentSelectedTabIndex: (state, action) => {
      state.currentSelectedTabIndex = action.payload
    },

    setCurrentServiceHistoryTabIndex: (state, action) => {
      state.currentSelectedServiceHistoryTabIndex = action.payload;
    },

    setCurrentActiveTab: (state, action) => {
      state.activeTab = action.payload
    },
    setShowUpdateService: (state, action) => {
      state.showUpdateService = action.payload
    },
    setIsServiceDetailSaveStatus: (state, action) => {
      state.isServiceAddressSaved = action.payload
    },
    setOpenDeleteServiceDetailTabConfirmationModal: (state) => {
      state.openDeleteServiceDetailTabModal = true
    },
    setCloseDeleteServiceDetailTabConfirmationModal: (state) => {
      state.openDeleteServiceDetailTabModal = false
    },
    resetCurrentSelectedTabIndex: (state) => {
      state.currentSelectedTabIndex = 0
    },
    resetCurrentSelectedServiceHistoryTabIndex: (state) => {
      state.currentSelectedServiceHistoryTabIndex = 0
    },

    resetServiceDetail: () => initialState,
  }
})

// Part 4
export const { setServiceAddressId, setServiceAddressList, setCurrentSelectedTabIndex, resetCurrentSelectedTabIndex, setSelectedTab, resetServiceDetail, setCurrentServiceHistoryTabIndex, resetCurrentSelectedServiceHistoryTabIndex, setSelectedServiceHistoryTab, setCurrentActiveTab, setShowUpdateService, setIsServiceDetailSaveStatus, setOpenDeleteServiceDetailTabConfirmationModal, setCloseDeleteServiceDetailTabConfirmationModal } = serviceDetailSlice.actions
export default serviceDetailSlice.reducer
